import React from "react";
import { useEffect, useRef, useState, useCallback } from "react";
import "./MyCanvas.css";
import { Button } from "antd"; //https://ant.design/components/button

function MyCanvas({
  width,
  height,
  className,
  captureScreenshot,
  clear,
  onClear,
  isSelected,
}) {
  const canvasRef = useRef(null);
  const [startX, setStartX] = useState(0);
  const [startY, setStartY] = useState(0);
  const [mouseX, setMouseX] = useState(0);
  const [mouseY, setMouseY] = useState(0);
  const [isDrawing, setIsDrawing] = useState(false);
  const [showButton, setShowButton] = useState(false);

  const clearCanvas = useCallback(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    if (clear) {
      context.clearRect(0, 0, canvas.width, canvas.height);
      onClear();
      setShowButton(false);
    }
  }, [clear, onClear, setShowButton]);

  //when the page is switched clear the canvas
  useEffect(() => {
    clearCanvas();
  }, [clear, onClear, clearCanvas]);

  useEffect(() => {
    if (isDrawing) {
      // console.log(
      //   "In handleMouseDown (after state update) X: " + startX + " Y:" + startY
      // );
    }
  }, [isDrawing, startX, startY]);

  useEffect(() => {
    const canvas = canvasRef.current;

    const handleMouseDown = (e) => {
      const rect = canvas.getBoundingClientRect();
      setStartX(e.clientX - rect.left);
      setStartY(e.clientY - rect.top);
      setMouseX(e.clientX - rect.left);
      setMouseY(e.clientY - rect.top);
      setIsDrawing(true);
    };

    const handleMouseMove = (e) => {
      if (!isDrawing) return;

      const rect = canvas.getBoundingClientRect();
      setMouseX(e.clientX - rect.left);
      setMouseY(e.clientY - rect.top);
    };

    const handleMouseUp = () => {
      // console.log("Mouse is up");
      setIsDrawing(false);
      setShowButton(true);
    };

    canvas.addEventListener("mousedown", handleMouseDown);
    canvas.addEventListener("mousemove", handleMouseMove);
    canvas.addEventListener("mouseup", handleMouseUp);

    return () => {
      canvas.removeEventListener("mousedown", handleMouseDown);
      canvas.removeEventListener("mousemove", handleMouseMove);
      canvas.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDrawing]);

  useEffect(() => {
    if (isDrawing && isSelected) {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.setLineDash([5, 5]);
      ctx.strokeStyle = "black";
      ctx.lineWidth = 2;
      ctx.strokeRect(startX, startY, mouseX - startX, mouseY - startY);
    }
  }, [isSelected, isDrawing, mouseX, mouseY, startX, startY]);

  return (
    <div>
      <canvas
        ref={canvasRef}
        width={width}
        height={height}
        className={className}
      />
      {showButton && !isDrawing && isSelected && (
        <Button
          type="primary"
          className="translate-button"
          style={{
            position: "absolute",
            left: mouseX + "px",
            top: mouseY + "px",
          }}
          onClick={captureScreenshot}
        >
          Translate
        </Button>
      )}
    </div>
  );
}

export default MyCanvas;
